import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../packages/ui';
import { OnboardingChecklist } from '../components/onboarding/OnboardingChecklist';
import { usePageTitle } from '../hooks/usePageTitle';

/** /welcome — where registration lands (U34): the first-use checklist. */
export function WelcomePage() {
    usePageTitle('Welcome');
    return (
        <div className="page" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)', maxWidth: 880 }}>
            <PageHeader title="Welcome to KaziAtlas" subtitle="Your workspace is ready. These steps check your real data as you go."
                actions={<Link className="btn btn-secondary btn-sm" to="/dashboard">Go to the dashboard</Link>} />
            <OnboardingChecklist variant="page" />
        </div>
    );
}
